import { Component, input } from '@angular/core';

@Component({
  selector: 'lib-round-icon',
  imports: [],
  templateUrl: './round-icon.html',
  styleUrl: './round-icon.scss',
})
export class RoundIcon {
  classNames = input('');
}
